<template>
    <div class="container">
        <div class="header">
            <i class="icon-fanhui iconfont back"
               @click="back"></i>
            <h2 v-if="pageName==1">审核提醒</h2>
            <h2 v-if="pageName==2">审核详情</h2>
        </div>
        <!-- 审核提醒页面1 -->
        <div class="content"
             v-if="pageName==1">
            <ul class="tabs">
                <li v-for="(item,index) in tabs"
                    :key="index"
                    :class="{'active':currentIndex==index}"
                    @click="changeTab(index)">{{item}}</li>
            </ul>
            <div class="list-wrapper">
                <div class="list-item"
                     v-for="(item,index) in examineList"
                     :key="index"
                     @click="goDetail(item.id,item.status)">
                    <div class="row">
                        <span>{{item.time}}</span>
                        <span>{{item.name}}</span>
                    </div>
                    <div class="row">
                        <span style="flex:3">{{item.project_name}}</span>
                        <span style="flex:2;position:relative;right:-2.4rem;">{{statusList[item.status]}}</span>
                    </div>
                    <div class="row">
                        <span class="numcolor">¥{{item.prefer_price}}</span>
                        <span class="numcolor">{{item.discount}}%</span>
                    </div>
                    <div class="row">
                        <span class="c_86898e">报价金额</span>
                        <span class="c_86898e">折扣</span>
                    </div>
                </div>
                <nodata v-if="!examineList.length"></nodata>

            </div>
            <!-- 审核提示详情页面 pageName=2-->
        </div>
        <div class="detail"
             v-if="pageName==2">
            <div class="examinedetail">
                <!-- 基础信息 -->
                <div class="basedata">
                    <p class="title">基础信息</p>
                    <ul class="m-l">
                        <li><span>报价名称:</span>{{baseData.project_name}}</li>
                        <li><span>甲方名称:</span>{{baseData.first_party}}</li>
                        <li><span>申请人:</span>{{baseData.name}}</li>
                        <li><span>合同价:</span>{{baseData.prefer_price}}</li>
                        <li><span>不含税总价:</span>{{baseData.total_price}}</li>
                        <li><span>含税总价:</span>{{baseData.final_price}}</li>
                        <li><span>折扣:</span>{{baseData.discount}}</li>
                        <li><span>签约:</span>{{baseData.status}}</li>
                        <li><span>备注:</span>{{baseData.remark}}</li>
                        <li><span>创建时间:</span>{{baseData.created_at}}</li>
                        <li><span>最后更新时间:</span>{{baseData.updated_at}}</li>
                    </ul>
                </div>
                <!-- 报价信息 -->
                <div class="quotedata">
                    <p class="title">报价信息</p>
                    <div>
                        <ul>
                            <!-- 基础报价 -->
                            <li class="quotelist"
                                v-if="quoteData.prices"
                                v-for="(item,index) in quoteData.prices"
                                :key="index">
                                <!-- 一级菜单 -->
                                <div>
                                    <span class="dot"></span>
                                    {{item.content}}
                                </div>
                                <!-- 二级菜单 -->
                                <div class="first"
                                     v-for="(a,aindex) in item.list"
                                     :key="aindex">
                                    <div class="no-child"
                                         v-if="!a.list">
                                        <div class="quote-title one">{{a.content}}:</div>
                                        <span ><span>数量:</span>&nbsp;&nbsp;&nbsp;x{{a.num}}&nbsp;&nbsp;{{a.unit}}</span>
                                        <span ><span>单价:</span>¥{{a.unit_price}}</span>
                                        <span>&nbsp;&nbsp;&nbsp; 税率:{{a.tax}}%</span>
                                        <span>&nbsp;&nbsp;&nbsp; 含税小计:¥{{a.final_money}}</span>
                                    </div>

                                    <div class="has-child"
                                         v-if="a.list">
                                        <span class="quote-title two">{{a.content}}:</span>
                                        <div v-for="(b,bindex) in a.list"
                                             :key="bindex">

                                            <div class="child no-grandchild"
                                                 v-if="!b.list">
                                                <div class="quote-title three">{{b.content}}</div>
                                                <div class="c-666">
                                                    <span ><span>数量:</span>&nbsp;&nbsp;&nbsp;x{{b.num}}&nbsp;&nbsp;{{b.unit}}</span>
                                                    <span ><span>单价:</span>¥{{b.unit_price}}</span>
                                                    <span>&nbsp;&nbsp;&nbsp;折扣:{{b.dis}}%</span>
                                                    <span>&nbsp;&nbsp;&nbsp; 税率:{{b.tax}}%</span>
                                                    <span>&nbsp;&nbsp;&nbsp; 含税小计:¥{{b.final_money}}</span>
                                                </div>

                                            </div>

                                            <div class="child has-grandchild"
                                                 v-if="b.list">
                                                <div class="quote-title quote-three-title">{{b.content}}</div>
                                                <div class="grandchild"
                                                     v-for="(c,cindex) in b.list"
                                                     :key="cindex">
                                                    <div class="quote-title four">{{c.content}}</div>
                                                    <div class="c-666">
                                                        <span ><span>数量:</span>&nbsp;&nbsp;&nbsp;x{{c.num}}&nbsp;&nbsp;{{c.unit}}</span>
                                                        <span ><span>单价:</span>&nbsp;¥{{c.unit_price}}</span>
                                                        <!-- <span><span v-html="getDis(c)"></span></span> -->
                                                        <span>&nbsp;&nbsp;&nbsp;折扣:{{c.dis}}%</span>
                                                        <span>&nbsp;&nbsp;&nbsp; 税率:{{c.tax}}%</span>
                                                        <span>&nbsp;&nbsp;&nbsp; 含税小计:¥{{c.final_money}}</span>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                                <!-- 二级菜单 -->
                            </li>
                            <!-- 其他报价 -->
                            <li v-if="quoteData.other_price&&quoteData.other_price.length>0">
                                <div class="quote-title type"
                                     style="font-size:12px;">
                                    <span class="dot"></span>
                                     其他报价
                                     </div>
                                <div v-for="(item,index) in quoteData.other_price"
                                     :key="index">
                                    <div class="no-child">
                                        <div class="quote-title one">{{item.content}}:</div>
                                        <div class="c-666">
                                            <span><span>数量:</span>&nbsp;&nbsp;&nbsp;x{{item.num}}&nbsp;&nbsp;{{item.unit}}</span>
                                            <span><span>单价:</span>&nbsp;&nbsp;¥&nbsp;{{item.unit_price}}</span>
                                            <span>&nbsp;&nbsp;&nbsp;折扣:{{item.dis}}%</span>
                                            <span>&nbsp;&nbsp;&nbsp; 税率:{{item.tax}}%</span>
                                            <span>&nbsp;&nbsp;&nbsp; 含税小计:¥{{item.total_price}}</span>
                                        </div>

                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- 备注 -->
                <div class="remarkdata">
                    <p class="title">备注</p>
                    <ul class="m-l">
                        <li v-for="(item,index) in remarkData"
                            :key="index">
                            <div class="c-666">
                                <span>{{item.created_at?item.created_at.slice(0,10):'--'}}</span>
                                <span>{{item.name}}</span>
                            </div>
                            <div>{{item.remark}}</div>
                        </li>
                    </ul>
                </div>
                <!-- 审核操作 -->
                <div class="auditOperation" v-if="canAudit">
                    <p class="title">审核操作</p>
                    <span class="passbtn"
                          @click="passBtn(baseData.id)">通过</span>
                    <span class="rejectbtn"
                          @click="rejectBtn(baseData.id)">驳回</span>
                </div>
                <!-- 添加留言 -->
                <!-- <div class="addLog" @click="addLogBtn(baseData.id)">添加留言</div> -->
                 <div class="leave-message">
                    <div>
                        <input type="text"
                            placeholder="请输入留言"
                            class="msg_in"
                            v-model="saveLog.remark" />
                        <span class="sendbtn"
                          @click="addLogBtn(baseData.id)">发送</span>
                    </div>
                </div>

            </div>
        </div>

    </div>
</template>
<script>
    import nodata from './public/nodata'
    import { MessageBox, } from 'mint-ui'


    export default {
        components: {
            nodata
        },
        data () {
            return {
                tabs: ['待审批', '已审批'],
                currentIndex: '',
                type: 1,//1待审批 2.已审批
                examineList: [],//审核数据
                statusList: [],//状态
                pageName: 1,
                canAudit:false,
                projectId: '',//项目id
                baseData: [],//基础信息
                quoteData: {},//报价信息
                remarkData: [],//备注信息
                review: {//审核参数
                    id: '',
                    status: '',
                },
                modal:false,//弹窗
                saveLog:{//留言
                    id:'',
                    remark:''
                }

            }
        },
        mounted () {
            this.getData()
        },
        methods: {
            //获取列表数据
            getData () {
                this.$http.getExamineList(this.type).then(res => {
                    this.examineList = res.data.data
                    this.statusList = res.data.status_list
                })
            },
            //获取详情数据
            getDetailData () {
                this.$http.getExamineDetail(this.projectId).then(res => {
                    if(res.errCode == '1001'){
                         MessageBox('提示', res.errMsg)
                         this.pageName=1
                         return
                    }
                    else{
                        console.log(res.data)
                        this.baseData = res.data.data//基础信息
                        this.quoteData = res.data.details//报价信息
                        this.remarkData = res.data.remark
                        this.pageName=2//如果有值，就跳转到详情信息页面。

                        this.canAudit = res.data.data.canAudit // 用来控制审核是否显示
                    }

                })
            },
            back () {
                if (this.pageName == 1) {
                    this.$router.push({name:'my'})
                }
                else if (this.pageName == 2) {
                    this.pageName = 1
                }
            },
            //改变标签
            changeTab (index) {
                this.currentIndex = index
                switch (index) {
                    case 0:
                        this.type = 1
                        break;
                    case 1:
                        this.type = 2
                        break;
                }
                this.getData()

            },
            //去到详情
            goDetail (pId,status) {
                this.projectId = pId
                 this.getDetailData()
                // this.pageName = 2//详情页面

            },
            //通过操作
            passBtn (pId) {
                this.review.id = pId
                this.review.status = 4
                this.$http.getupdateReview(this.review).then(res => {
                   if(res.errCode == 0){
                        MessageBox('提示', '审核成功')
                            // this.getData()
                             this.getDetailData()
                   }else {
                       MessageBox('提示', res.errMsg)
                   }
                })
            },
            //驳回操作
            rejectBtn (pId) {
                const html = `
                    <div style="font-size:14px;border:1px solid #ccc;height:6rem" >
                    <textarea placeholder="输入内容" style="font-size:14px;height:5.5rem;width:100%;" v-model="review.remark"></textarea>
                    </div>
                `
                MessageBox.prompt('请输入驳回原因').then(({ value, action }) => {
                    if (action == 'confirm') {     //确认的回调
                    this.review.status=3;
                     this.review.id = pId
                     this.review.remark=value
                        this.$http.getupdateReview(this.review).then(res => {
                            if (res.errCode == 0) {
                                MessageBox('提示', '驳回成功')
                                // this.getData()
                                 this.getDetailData()
                            }else {
                                MessageBox('提示', res.errMsg)
                            }
                        })
                    }
                    if (action == 'cancel') {     //确认的回调
                        console.log(cancel)
                    }
                });
            },
            //添加留言
            addLogBtn(pId){
                        this.saveLog.id=pId
                        this.$http.getsaveLog(this.saveLog).then(res => {
                            if (res.errCode == 0) {
                                MessageBox('提示', '留言成功')
                                this.getDetailData()
                                this.saveLog.remark=''
                            }else {
                                MessageBox('提示', res.errMsg)
                            }
                        })
                    },




        }
    }
</script>
<style scoped>
    .container {
      color: #333;
      width: 100vw;
      height: 100vh;
      font-family: PingFangSC-Regular;
    }
    .header {
      width: 100%;
      color: #000;
      text-align: center;
      font-size: 0.375rem;
      background-color: #fff;
      height: 7%;
      position: relative;
    }
    .header h2 {
      color: #333;
      font-size: 0.4375rem;
      border-bottom: 1px solid #ddd;
      height: 100%;
      padding-top: 3.5%;
    }

    .back {
      display: inline-block;
      position: absolute;
      left: 0.3125rem;
      top: 18%;
      font-weight: bold;
      height: 0.78125rem;
      line-height: 0.78125rem;
      color: #86898e;
    }
    .tabs li {
      display: inline-block;
      margin-right: 1rem;
      height: 1rem;
      line-height: 1rem;
      margin-bottom: 0.2rem;
    }
    .active {
      border-bottom: 0.0625rem solid #5483d2;
    }
    .list-wrapper {
      overflow: scroll;
      padding-bottom: 3.8rem;
      margin-left: 0;
    }
    .row {
      display: flex;
      color: #666;
      font-size: 12px;
    }
    .numcolor {
      color: #5483d2;
      font-size: 16px;
      font-weight: 400;
    }
    .c_86898e {
      color: #86898e;
      margin: 0 10px;
    }
    .examinedetail {
      padding: 10px;
    }
    .title{
        font-size: 14px
    }
    .basedata,
    .quotedata,
    .remarkdata,
    .auditOperation {
      border: 1px solid #ccc;
      border-radius: 4px;
      margin-top: 0.2rem;
      padding-bottom: 0.2rem;
      padding:0.1rem;
     margin-bottom: 2rem;
    }
    .remarkdata{
        margin-bottom:2rem;
    }
    .m-l {
      margin-left: 0.2rem;
    }
    .dot {
      display: inline-block;
      height: 5px;
      width: 5px;
      background-color: #4986f9;
      border-radius: 50%;
      margin-right: 5px;
    }
    .no-child,
    .has-child {
      margin-left: 20px;
      margin-top: 10px;
    }
    .child.no-grandchild {
      margin-left: 20px;
    }
    .quote-title {
      /* width: 200px; */
      /* overflow: hidden; */
      /* text-overflow: ellipsis; */
      /* white-space: nowrap; */
      /* display: inline-block; */
    }
    .quote-title.type {
      display: flex;
      /* color:rgb(73, 134, 249); */
      font-size: 14px;
      align-items: center;
      margin: 10px 0;
    }
    .c-666 {
      color: #666;
    }
    .dis,.num1,.unit1{
        display: inline-block;
        width:2.5rem;
    }
    .num1{
         width:2.5rem;
         /* 单价 */
    }
    .unit1{
         width:3rem;
    }
    .passbtn,
    .rejectbtn {
      margin-left: 0.5rem;
      background-color: rgb(212, 111, 67);
      color: rgb(255, 255, 255);
      display: inline-block;
      width: 1.2rem;
      height: 0.8rem;
      line-height: 0.8rem;
      text-align: center;
      border-radius: 0.16rem;
      margin-top: 0.2rem;
    }
    .passbtn {
      background-color: rgb(228, 187, 81);
      color: rgb(255, 255, 255);
    }
    .addLog{
        width:1.8rem;
        height: 0.8rem;
         background-color: #4986f9;
          color: rgb(255, 255, 255);
          border-radius: 0.2rem;
          line-height: 0.8rem;
          text-align: center ;
          margin-top:10px;
    }
        /* 留言弹窗 */
    .leave-message {
      position: absolute;
      bottom: 0;
      width: 100%;
      background: #fff;
      height: 1.5rem;
      padding: 10px;
    }
    .msg_in {
      width: 100%;
      border-radius: 0.3rem;
      border: 1px solid #ccc;
      height: 1rem;
      width: 80%;
      margin-left: 0.2rem;
      padding-left: 0.1rem;
    }
    .sendbtn {
      display: inline-block;
      background: #5483d2;
      display: inline-block;
      width: 1.2rem;
      height: 0.9rem;
      line-height: 0.9rem;
      text-align: center;
      border-radius: 20%;
      color: #fff;
    }
</style>




// WEBPACK FOOTER //
// src/components/Examine.vue